import React, { useEffect } from "react";
import DomPurify from "dompurify";
import ChatMessage from "./ChatMessage";
import ChatMessageInput from "./ChatMessageInput";
import { ChatMessageButtonInterface } from "../interfaces";
import ChatMessageButtonOptions from "./ChatMessageButtonOptions";
import { useAppSelector } from "../store/hooks";

const ChatMessageButton: React.FC<ChatMessageButtonInterface> = ({
  hideAvatar,
  handleInputSubmit,
  triggerNextStep,
  values = {},
  step,
  setDataValues,
  currentStep,
  scrollToBottom,
  disableScrollToBottom,
  disableTypingAnimation,
}) => {
  const messages = useAppSelector((state) => state.chat.messages);
  const { options, message, theme, type, input } = step!;

  useEffect(() => {
    if (!disableScrollToBottom && step === currentStep) {
      scrollToBottom!();
    }
  });

  return (
    <div
      className={`conversation-message-button-wrapper conversation-message-button-wrapper-${type}`}
    >
      {message && (
        <ChatMessage
          step={step}
          hideAvatar={hideAvatar}
          disableTypingAnimation={disableTypingAnimation}
          scrollToBottom={scrollToBottom}
          render={() => (
            <div
              className="conversation-message-bubble-text"
              dangerouslySetInnerHTML={{
                __html: DomPurify.sanitize(message),
              }}
            />
          )}
        />
      )}

      {(options?.length ||
        theme?.apiKey === "abde4f0e-b4de-4166-8c87-a0bdf1500bb6" ||
        theme?.apiKey === "0155d30f-961b-42b8-9b07-7386aeb48913") && (
        <ChatMessageButtonOptions
          step={step!}
          setDataValues={setDataValues}
          triggerNextStep={triggerNextStep!}
          values={values}
          options={options}
          theme={theme!}
        />
      )}

      {input &&
        input.type !== "typeahead" &&
        step?.id === messages[messages.length - 1]?.id && (
          <ChatMessageInput
            currentStep={currentStep}
            triggerNextStep={triggerNextStep}
            step={step}
            values={values}
            disableTypingAnimation={disableTypingAnimation}
            handleInputSubmit={handleInputSubmit}
            setDataValues={setDataValues}
          />
        )}
    </div>
  );
};

export default React.memo(ChatMessageButton);
